import { colors, IMForm, IMInputText } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  max-width: none;
  width: 100%;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 4rem 10rem 8rem;
  margin: 0;
  min-height: 40rem;
  align-content: flex-start;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const IMInputTextStyled = styled(IMInputText)`
  ${breakpointsMQ4.xl.down} {
    flex-basis: 100%;
  }
`;
